'use client'
import { useBlogHomePage } from "@/providers/strapi/content/types/singleTypes/blog-home-page";
import { Article, ArticleList } from "./common";
import { PageProps } from "@/types";

export function MostLoved(props: PageProps<{
  articles: Article[];
}>) {
  // const tr = X.useTranslator(props);
  const featuredArticlesCard = useBlogHomePage('featuredArticlesCard');
  const moreArticleCta = useBlogHomePage('moreArticleCta')


  return (
    <ArticleList
      locale={props.locale}
      articles={props.articles}
      title={
        // tr({
        //   en: "Most loved articles",
        //   fr: "Articles les plus appréciés",
        // })
        featuredArticlesCard.title}
      button={{
        type: "link",
        href: "/blog/tag",
        label: moreArticleCta
        // label: tr({
        //   en: "Discover all our articles",
        //   fr: "Découvrez tous nos articles",
        // }),
      }}
      moreArticleCta={""}
      moreArticleCtaLoadingState={""} />
  );
}
